import React from 'react';

const FwUserIcon = ({ color = 'currentColor', size = '16px' }) => {
  return <i className='fas fa-user-circle' style={{ color, fontSize: size }}></i>;
};

export default FwUserIcon;
